<template>
    <div>
        <el-container style="width: 1024px;margin: auto;margin-top:50px;">
            <el-header class="el-card" style="height:100px;padding: 30px;">
                <img src="./img/icon.png" style="height:40px;" />
                <div style="float:right;font-size: 35px;">
                    <el-button style="font-size: 22px;" type="text" @click="$router.push('/WorkSpace/0')">设计器
                    </el-button>
                    <template v-if="user && user.level < 2">
                        <el-button style="font-size: 22px;" type="text">|
                        </el-button>
                        <el-button style="font-size: 22px;" type="text" @click="$router.push('/SamplePage')">案例库
                        </el-button>
                    </template>
                    <template v-if="user && user.level == 0">
                        <el-button type="text" @click="$router.push('/UserManager')">用户管理
                        </el-button>
                    </template>
                    <el-button type="text" @click="Logout()">退出
                    </el-button>
                </div>
            </el-header>
            <el-main>
            </el-main>
            <div class="content_wrap">
                <div class="content_item" v-for="(item) in projects" :key="item.id">
                    <h3 style="margin:10px 0">{{ item.name }}
                    </h3>
                    <div style="position:relative;" v-if="item.progress != 100" class="img_wrap">
                        <img src="./img/a.png" alt="" style="filter: blur(5px);" />
                        <el-progress style="position:absolute;top:50%;width:100%;" :text-inside="true"
                            :stroke-width="20" :percentage="item.progress"></el-progress>
                    </div>
                    <div v-if="item.progress == 100" class="img_wrap" @click="openProject(item)">
                        <DesignerView style="width:150px;height:120px;margin:auto" :data="item" :height="120"
                            :width="150"></DesignerView>
                    </div>
                    <div class="AuthorAndDownload">
                        <span>{{ item.time }}</span>
                        <i @click="delProj(item)" class="el-icon-delete"></i>
                        <i @click="download(item)" class="el-icon-download"></i>
                    </div>
                </div>
            </div>
            <el-footer>
                <el-pagination @current-change="pageChange" :current-page="pager.currentPage"
                    :page-sizes="[5, 10, 20, 100]" :page-size="pager.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="pager.total" style="text-align:right;">
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>
<script>
import axios from "axios";
import DesignerView from './components/DesignerView.vue'
import { baseUrl } from "./config/baseUrl.js";
import { commit_rooms } from './api/options';
import { getUser, logout } from './api/user';
import { getInstance } from './api/orm';
export default {
    name: "home-page",
    components: { DesignerView },
    data: () => {
        return {
            user: null,
            projects: [],
            search_text: '',
            sort_type: '',
            pager: {
                currentPage: 1,
                total: 1,
                size: 10
            }
        };
    },
    async created() {
        let user = await getUser();
        if (!user) {
            this.$router.push("/LoginPage");
            return;
        }
        this.user = user;
        await this.search();
    },
    methods: {
        async pageChange(p) {
            this.pager.currentPage = p;
            await this.search();
        },
        goUser() {
            this.$router.push("/UserManager");
        },
        async delProj(item) {
            await axios.post(`${baseUrl}/design/design/delete`, [{ 'id': item.id }]);
            await this.search();
        },
        newProject() {
            this.$router.push("/WorkSpace/0");
        },
        openProject(row) {
            if (!row.duration) {
                this.$message.error("此任务还没有计算完成，不能查看！");
                return;
            }
            this.$router.push("/WorkSpace/" + row.id);
        },
        async search(p) {
            let orm = getInstance({ app_name: 'design', model_name: 'design' });
            let cond = [{ page: this.pager.currentPage, limit: this.pager.size, condition: `(locate('${this.search_text}',name))` }];
            if (this.user.level != 0) {
                cond.push({ creator_id: this.user.id });
            }
            let data = await orm.select({
                post: cond
            });
            this.projects = data.data;
            this.pager.currentPage = data.pageindex;
            this.pager.total = data.datacount;
            this.pager.size = data.pagesize;
        },
        async download(item) {
            let res = await axios.post(`${baseUrl}/design/design/download?id=${item.id}`, {});
            window.location.href = `${baseUrl}${res.data.data}`
            console.log('download', res);
        },
        async Logout() {
            logout();
            this.$router.push("/LoginPage");
        }
    },
};
</script>
<style scoped>
body {
    box-sizing: border-box;
}

.action_wrap {
    display: flex;
    align-items: center;
    justify-content: right;
    padding-right: 20px;
}

.action_wrap .s_inp {
    width: 150px;
    margin-right: 20px;
}

.content_wrap {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.content_wrap .content_item {
    width: 150px;
    margin: 17px;
    background: #fff;
    box-shadow: 1px 2px 20px 2px rgba(0, 0, 0, 0.123);
    padding: 10px;
}

.content_wrap .content_item .img_wrap {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 120px;
    width: 100%;
    text-align: center;
}

.content_wrap .content_item .img_wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.AuthorAndDownload {
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.AuthorAndDownload img {
    width: 20px;
}

.mask {
    background: #487489;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 99999;
    display: flex;
    align-items: center;
}

.fade_out {
    opacity: 0;
    transition-duration: 1s;
    transition-property: opacity;
}
</style>